module.exports = __webpack_public_path__ + "static/page2-c82cbc4cd89d544278f3f15586e0097e.png";